<template>
<div>
    <div v-if="!isMobile" class="main-body desktop ">
        <div class="circles">
            <div class="big-circle"></div>
            <div class="medium-circle"></div>
            <div class="small-circle"></div>
        </div>
        <div class="site-header">
            <router-link class="brand p-2" to="/">
                <img class="logo-img" src="@/assets/images/cs-logo-light.svg" alt="" />
            </router-link>
        </div>
        <b-row>
            <b-col cols="5"></b-col>
            <b-col cols="5">
                <p class="font32">Payment Details</p>
                <hr>
                <p class="">
                    Please add card details to make payment
                </p>
                <div class="ul-widget-list__payment-method mb-3">
                    <img class="mr-2" src="@/assets/images/master-card.png" style="width: 50px" alt="" srcset="" />
                    <img class="mr-2" src="@/assets/images/visa.png" style="width: 50px" />
                    <img class="mr-2" src="@/assets/images/paypal.png" style="width: 50px" />
                </div>
                <div class="mt-5">
                    <p class="font18">
                        Billing Information
                    </p>
                    <p class="d-flex">
                        Same as shipping information
                        <b-form-checkbox v-model="checked" name="check-button" switch> {{checked == false? 'No': 'Yes'}}</b-form-checkbox>
                    </p>
                </div>
                <b-card class=" payment-simple">
                    <b-form-group class=" mb-4" label-for="name">
                        <b-input-group class="">
                            <b-form-input type="text" required :class="{ complete }" v-model="name" placeholder="Name on card"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class=" mb-4" label-for="email">
                        <b-input-group class="">
                            <b-form-input type="text" required :class="{ complete }" v-model="email" placeholder="Enter your email"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-for="card">
                        <stripe-element-card @element-ready='cardComplete' ref="elementRef" :pk="testKey" @token="tokenCreated" :elementsOptions="stripeOptions" />
                        <!-- <card ref='cardElement' class="stripe-card" :class="{ complete }" :stripe="liveKey" :options="stripeOptions" @change="complete = $event.complete" /> -->
                    </b-form-group>
                    <b-form-group label-for="card">
                        <stripe-element-card @element-ready='cardComplete' ref="elRef" :pk="testKey" @token="tokenCreated" :elementsOptions="stripeOptions" />
                        <!-- <card ref='cardElement' class="stripe-card" :class="{ complete }" :stripe="liveKey" :options="stripeOptions" @change="complete = $event.complete" /> -->
                    </b-form-group>
                    <div class="text-center mt-6 conf-btns">
                        <button @click="submit" style="color:#fff" class="btn btn-warning " :disabled="!complete">
                            {{payBtn}} {{ currency }} {{ amount }}
                        </button>
                        <div v-if="sloading" class="spinner spinner-primary ml-3 mr-3"></div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <div class="foot-text">
            <p>Welcome to Culture Square</p>
        </div>

    </div>
    <div v-if="isMobile" class="mobile">
        <AbstractHeader />
        <div class="form-box">
            <p class="text-center font18">Payment Details</p>
            <p class="text-center font12">
                Please add card details to make payment
            </p>
            <div class="text-center ul-widget-list__payment-method mb-3">
                <img class="mr-2" src="@/assets/images/master-card.png" style="width: 50px" alt="" srcset="" />
                <img class="mr-2" src="@/assets/images/visa.png" style="width: 50px" />
                <img class="mr-2" src="@/assets/images/paypal.png" style="width: 50px" />
            </div>
            <div class="mt-5">
                <p class="font18">
                    Billing Information
                </p>
                <p class="d-flex">
                    Same as shipping information
                    <b-form-checkbox v-model="checked" name="check-button" switch> {{checked == false? 'No': 'Yes'}}</b-form-checkbox>
                </p>
            </div>
            <b-card class=" payment-simple">
                <b-form-group class=" mb-4" label-for="name">
                    <b-input-group class="">
                        <b-form-input type="text" required :class="{ complete }" v-model="name" placeholder="Name on card"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-group class=" mb-4" label-for="email">
                    <b-input-group class="">
                        <b-form-input type="text" required :class="{ complete }" v-model="email" placeholder="Enter your email"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-group label-for="card">
                    <stripe-element-card @element-ready='cardComplete' ref="elementRef" :pk="testKey" @token="tokenCreated" :elementsOptions="stripeOptions" />
                    <!-- <card ref='cardElement' class="stripe-card" :class="{ complete }" :stripe="liveKey" :options="stripeOptions" @change="complete = $event.complete" /> -->
                </b-form-group>
                <div class="text-center mt-6 conf-btns">
                    <button @click="submit" style="color:#fff" class="btn btn-warning " :disabled="!complete">
                        {{payBtn}} {{ currency }} {{ amount }}
                    </button>
                    <div v-if="sloading" class="spinner spinner-primary ml-3 mr-3"></div>
                </div>
            </b-card>

        </div>
    </div>
</div>
</template>

<script>
import axios from "axios";
import AbstractHeader from "@/components/AbstractHeader.vue";
import {
    getBaseUrl
} from "../../../utils/common";
const base_url = getBaseUrl();

import {
    StripeElementCard
} from '@vue-stripe/vue-stripe';

export default {
    props: ["stripe", "options"],
    data: () => ({
        error: false,
        success: false,
        sloading: false,
        successmessage: "",
        payBtn: 'Confirm and Pay',
        errormessage: "",
        focus: "",
        complete: false,
        name: "",
        email: "",
        loading: false,
        event: {},
        token: null,
        checked: false,
        client_secret: '',
        liveKey: process.env.VUE_APP_STRIPE_LIVE,
        testKey: process.env.VUE_APP_STRIPE_TEST,
        booking: {
            auth_user_id: "",
            host_id: "",
            event_id: "",
        },
        currency: "",
        amount: "",
        isMobile: false,
        stripeOptions: {
            style: {
                base: {
                    color: "#495057",
                    fontSmoothing: "antialiased",
                    fontFamily:"Montserrat",
                    lineHeight: "1.5",
                    fontSize: "16px",
                    "::placeholder": {
                        color: "#495057",
                    },
                },
                invalid: {
                    color: "#fa755a",
                    iconColor: "#fa755a",
                },
            },
            hidePostalCode: true,
        },
    }),
    components: {
        AbstractHeader,
        StripeElementCard,

    },
    async beforeRouteLeave(to, from, next) {
        if (to.name === 'payment-successful' && !from.params.order.singleProduct) {
            await this.$store.dispatch("resetCart")
        }
        next();
    },
    mounted() {
        //console.log(this.$route.params.order)
        let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        if (width <= 360) {
            this.isMobile = true
        }
        console.log("mobile", this.isMobile);
    },
    computed: {
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        },
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
        base_url: function () {
            return base_url;
        },
    },
    watch: {
        checked: function (val) {
            if (val) {
                this.name = this.$route.params.order.recipient_info[0].name
                this.email = this.$route.params.order.recipient_info[0].email
            } else {
                this.name = '';
                this.email = '';
            }
        },
    },
    methods: {
        async getEvent() {
            const event_booking_id = this.$route.params.id;
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/eventactions/${event_booking_id}?action=pre-payment&section=course`,
                    method: "GET",
                })
                this.client_secret = resp.data.data.stripe_client_secret
            } catch (error) {
                this.$router.push('/event-expired')
                //this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        },
        submit() {
            this.$refs.elementRef.submit();
        },
        tokenCreated(token) {
            this.token = token;
            this.confirmPayment();
        },
        cardComplete() {
            this.complete = true
        },
        async confirmPayment() {
            this.payBtn = 'Processing...';
            let self = this;
            if (this.name && this.email) {
                const result = await this.$stripe.confirmCardPayment(
                    self.client_secret, {
                        payment_method: {
                            card: {
                                token: this.token.id
                            },
                            billing_details: {
                                name: self.name,
                                email: self.email,
                            },
                        }
                    },
                );
                if (result.error) {
                    this.$root.$refs.A.makeToast('danger', result.error.message)
                } else {
                    // The payment has been processed!
                    if (result.paymentIntent.status === "succeeded") {
                        this.charge = {
                            amount: result.paymentIntent.amount, // the amount you want to charge the customer in cents. $100 is 1000 (it is strongly recommended you use a product id and quantity and get calculate this on the backend to avoid people manipulating the cost)
                            event_booking_id: this.$route.params.id,
                            currency: this.currency,
                            name: this.name,
                            email: this.email,
                            token: this.token.id,
                            payment_ref: result.paymentIntent.id
                        };
                        try {
                            const response = await axios({
                                url: `${base_url}/api/v2/eventactions/${this.charge.event_booking_id}?action=post-payment&section=course`,
                                data: this.charge,
                                method: "PUT",
                            })
                            this.payBtn = 'Confirm and Pay';
                            if (response.data.data === false) {
                                this.$router.push("/payment-failed");
                            } else {
                                this.$router.push("/payment-successful");
                            }
                        } catch (error) {
                            this.$router.push("/payment-failed");
                        }
                    }
                }
            } else {
                this.payBtn = 'Confirm and Pay';
                this.$root.$refs.A.makeToast('danger', 'Please enter your name and email')

            }
        },
    },
};
</script>

<style lang="scss" scoped>
.mrgtop {
    margin-top: 25% !important;
}

// .form-control {
//     border: 1px solid #ced4da !important;
// }

.spinner {
    font-size: 5px !important;
}

.mrgtop10 {
    margin-top: 10% !important;
}

/* .StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
} */

.StripeElement--invalid {
    border-color: #fa755a;
}

.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
}

.stripe-card {
    width: 100%;
    border: none;
    border-radius: 0.25rem;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
}

.stripe-card.complete {
    border-color: green;
}

.main-body {
    background-image: url('~@/assets/images/abstract.svg');
    background-repeat: no-repeat;
    height: 100vh
}

.form-control {
    height: calc(1.5em + 0.75rem + 15px) !important;
}

.logo-img {
    position: fixed;
    width: 8%
}

.site-header {
    padding: 30px 50px;
}

.circles {
    position: absolute
}

.big-circle {
    position: relative;
    left: 191%;
    top: -58px;
    height: 190px;
    width: 190px;
    border-radius: 50%;
    background: #F7B131;
}

.medium-circle {
    position: relative;
    left: 295%;
    top: -90px;
    height: 100px;
    width: 100px;
    border-radius: 50%;
    background: #F7B131;
}

.small-circle {
    position: relative;
    left: 300%;
    top: -50px;
    height: 62px;
    width: 62px;
    border-radius: 50%;
    background: #F7B131;
}

.form-container {
    background: none;
    box-shadow: none;
    padding: 30px 15px 15px 0px !important;
}

a {
    color: #F7B131;
}

.form-box {
    padding: 20px 75px 50px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 40px 20px 20px 20px;
    }
}

.form-box p:first-child {
    font-size: 28px;
    border-bottom: 1px solid #E0E0E0;
}

.foot-text {
    color: #fff;
    position: fixed;
    bottom: 0;
    padding-bottom: 1rem
}

.foot-text p {
    padding-left: 2.5rem;
    font-size: 14px
}

.foot-text ul {
    display: flex
}

.foot-text ul>li {
    margin: 0 10px;
}

.button-contain {
    margin-top: 40px;

}

.button-contain button {
    width: 100%
}

.svg-inline--fa {
    height: 0.7em !important
}

@media screen and (min-width: 1400px) {
    .main-body {
        height: 100vh;
    }

    .big-circle {
        position: relative;
        left: 191%;
        top: -58px;
        height: 211px;
        width: 211px;
        border-radius: 50%;
        background: #F7B131;
    }

    .medium-circle {
        position: relative;
        left: 285%;
        top: -90px;
        height: 129px;
        width: 129px;
        border-radius: 50%;
        background: #F7B131;
    }

    .small-circle {
        position: relative;
        left: 280%;
        top: -50px;
        height: 62px;
        width: 62px;
        border-radius: 50%;
        background: #F7B131;
    }
}
</style>
